var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bt-transaksi pb-5 mb-5"},[_c('Pembiayaan'),_c('Tabungan'),_c('Others')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }